import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceBoolean, coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import z from 'zod';

export default createPerformableConfig(
  'custom',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      description: z.string(),
      onsite: z.coerce.number().optional(),
      revenue: z.coerce.number().optional(),
      // Sales tax applies to this line (New Jersey taxes item by item).
      // Absent = untaxed, as custom lines always were.
      taxable: coerceBoolean().optional(),
      // The Bleenk package tier this line delivers ('sky_to_door_tour') —
      // the Bleenk handoff keys the flythrough on it (orderBleenkPackage).
      package: z.string().optional(),
      // The package this line delivers includes MCM's branded 16:9 slideshow at no
      // charge (McmOrder.slideshows): no Slideshow line, no price, no tax,
      // no provider pay. Written only by the Sky-to-Door tier, and only on
      // lines booked once this shipped: an earlier line carries none, so
      // its order is unchanged.
      slideshow: coerceBoolean().optional(),
    }),
  },
  {
    name: 'Custom Service',
    short: '',
    tenant: TenantId.MOTION_CITY_MEDIA,
    thumbnail: '',
    images: [],
  },
);
